import { render, staticRenderFns } from "./shopAdd.vue?vue&type=template&id=07e524f5&scoped=true"
import script from "./shopAdd.vue?vue&type=script&lang=js"
export * from "./shopAdd.vue?vue&type=script&lang=js"
import style0 from "./shopAdd.vue?vue&type=style&index=0&id=07e524f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e524f5",
  null
  
)

export default component.exports